import React from "react";
import { Avatar, Badge } from "antd";
import { StarFilled } from "@ant-design/icons";
import { getToken } from "services/token-service/token.service";
import NOIMAGE from "assets/images/no_image.jpeg";

import "./AgentItem.scss";
const AgentItem = (props) => {
  const { adminData } = props;
  const token = getToken();
  const statusClass =
    adminData.status === "offline"
      ? "AgentStatus Offline"
      : adminData.status === "online"
      ? "AgentStatus Active"
      : adminData.status === "idle"
      ? "AgentStatus Idle"
      : "AgentStatus";

  return (
    <div className="AgentItem">
      <div className="SingleItem AgentInfo">
        <div className="AgentUsername">{adminData.username}</div>
        <div className={statusClass}>{adminData.status}</div>
      </div>
      <div className="SingleItem MessagePreview">
        {adminData.claimed_conversation &&
          adminData.claimed_conversation.latest_message_body}
      </div>
      <div className="SingleItem UserInfo">
        {adminData.claimed_conversation && (
          <>
            <div>
              <Avatar
                src={
                  adminData.claimed_conversation.fictitious_profile
                    .profile_image
                }
              />
            </div>
            <div>
              {adminData.claimed_conversation.fictitious_profile.username}
            </div>
          </>
        )}
      </div>
      <div className="SingleItem UserInfo">
        {adminData.claimed_conversation && (
          <>
            <div>
              {adminData.claimed_conversation.user_profile.profile_image ? (
                <Avatar
                  src={`${adminData.claimed_conversation.user_profile.profile_image}?token=${token}`}
                />
              ) : (
                <Avatar src={`${NOIMAGE}`} />
              )}
            </div>
            <div>{adminData.claimed_conversation.user_profile.username}</div>
          </>
        )}
      </div>
      <div className="SingleItem PremiumStatus">
        {adminData.claimed_conversation && (
          <>
            {adminData.claimed_conversation.user_profile.premium && (
              <StarFilled className="StarPremium" />
            )}
            {adminData.claimed_conversation.user_profile.online_status ? (
              <Badge color="green" />
            ) : (
              <Badge color="grey" />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AgentItem;
